import { render } from "./infinity-icon.svg?vue&type=template&id=6eafb65e"
import script from "./infinity-icon.svg?vue&type=script&lang=js"
export * from "./infinity-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3637/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__